export default __webpack_public_path__ + "static/media/logo-ec0f69.3cd604e9.svg";